const NotificationHandler = {};

const DEFAULT_NOTIFICATION_EXPIRE_TIME = 10000;
const NotificationType = { SUCCESS: 'success', INFO: 'info', WARNING: 'warning', ERROR: 'error' };
const NotificationIcon = { SUCCESS: 'check_circle', INFO: 'info', WARNING: 'warning', ERROR: 'error' };
const NotificationState = { CREATED: 'created', ANIMATE_IN: 'animate_in', WAITING_FOR_INTERACTION: 'waiting', ANIMATE_OUT: 'animate_out', DISTROYED: 'distroyed' };

var audio_player = {};
import NOTIFICATION_SOUND from '../audio/notification_sound.wav';
audio_player.notification = new Audio(NOTIFICATION_SOUND); //new Audio("/audio/notification_sound.wav"); //new Audio("./audio/notification_sound.wav");

NotificationHandler.NotificationButton = class NotificationButton {
	init() {
		this.styles = ['default'];
		this.style = 'notification_button_' + 'default';
		this.onclick = () => {};
		this.text = '';
		this.id = 'button' + _chr4();
		this.dismiss_notification_after_click = true;
		this.classList = 'notification_button';
		this.distructive = false;
		this.active_button = false;
		this.custom_css = '';
	}
	constructor(text, on_click, options = {}, id) {
		this.init();
		if (on_click != undefined || null) {
			this.onclick = on_click;
		}
		if (text != undefined || null) {
			this.text = text;
		}
		if (id != undefined || null) {
			this.id = id;
		}
		if (options != undefined || null) {
			if (options.dismiss_notification_after_click != undefined || null) {
				this.dismiss_notification_after_click = options.dismiss_notification_after_click;
			}
			if (options.destructive != undefined || null) {
				this.destructive = options.destructive;
			}
			if (options.custom_css != undefined || null) {
				this.custom_css = options.custom_css;
			}
		}
	}

	_chr4() {
		return Math.random().toString(16).slice(-4);
	}
};

NotificationHandler.Notification = class Notification {
	__init() {
		this.identifier = '';
		this.title = '';
		this.body = '';
		this.action_buttons = [];
		this.play_sound = true;
		this.custom_html = '';
		this.isBanner = false;
		this.has_close_button = false;

		this.icon = NotificationIcon.SUCCESS; //Can be custom
		this.type = NotificationType.SUCCESS;
		this.state = NotificationState.CREATED;
		this.options = {};

		this.animation = { in_duration: 7, out_duration: 90 };
		this.bounds = { top: 0, right: -300, height: 0 };
		this.element = undefined;

		this.__animateInBound = this.__animate_in.bind(this);
		this.__animateOutBound = this.__animate_out.bind(this);
	}

	constructor(title = '', body = '', buttons = [], notification_type = NotificationType.SUCCESS, options = {}) {
		this.__init();
		this.title = title;
		this.body = body;
		this.action_buttons = typeof buttons == 'object' && buttons != null && buttons != undefined ? buttons : [];
		if (this.action_buttons.length <= 0) {
			// this.action_buttons = [new NotificationButton("Cancel", () => {}, {dismiss_notification_after_click: true})];
			this.has_close_button = true;
			if (this.options.isBanner == undefined) {
				this.isBanner = true;
			} //Only set to true if a overriding value wasn't also included in the options object
		}
		this.type = notification_type;
		this.icon = notification_type == 'success' ? NotificationIcon.SUCCESS : notification_type;
		if (options.icon != undefined) {
			this.icon = options.icon;
		}

		const _chr4 = () => {
			return Math.random().toString(16).slice(-4);
		};

		this.identifier = 'notification_' + (_chr4() + _chr4() + _chr4() + _chr4() + _chr4());
		this.options = options;
		if (this.options.expire_time == undefined || null) {
			this.options.expire_time = DEFAULT_NOTIFICATION_EXPIRE_TIME;
		}
		if (this.options.play_sound != undefined || null) {
			this.play_sound = this.options.play_sound;
		}
		if (this.options.has_close_button != undefined || null) {
			this.has_close_button = this.options.has_close_button;
			this.isBanner = true;
		}
		if (this.options.isBanner != undefined || null) {
			this.isBanner = this.options.isBanner;
			this.has_close_button = true;
		}
	}

	set buttons(array) {
		if (typeof array == 'object' && array != null && array != undefined) {
			this.action_buttons = array;
		}
		if (this.action_buttons.length <= 0) {
			// let cancel_button = new NotificationButton('Cancel', () => {}, { dismiss_notification_after_click: true });
			console.log('cancel button');
		}
	}

	set DOMElement(element) {
		if (element != undefined && element != null) {
			this.element = element;
			this.bounds.top = element.style.top || 0;
			this.bounds.right = element.style.right || -300;
			this.bounds.height = element.offsetHeight; //$(element).height();
			this.bounds.alpha = element.style.opacity || 1;
		}
	}

	__onDidCreate() {
		if (this.options.expire_time != undefined && this.options.expire_time != 0) {
			this.expire_timeout = setTimeout(() => {
				console.log('Hide');
				NotificationCenter.removeDeliveredNotificationsWithIdentifiers([this.identifier]);
			}, this.options.expire_time);
		}
		this.startAnimationIn();
		if (this.play_sound) {
			audio_player.notification.play();
		}
	}

	startAnimationIn() {
		this.state = NotificationState.ANIMATE_IN;
		this.animation.in_animation_start_time = performance.now();
		requestAnimationFrame(this.__animateInBound);
	}

	startAnimationOut() {
		this.state = NotificationState.ANIMATE_OUT;
		this.animation.out_animation_start_time = performance.now();
		requestAnimationFrame(this.__animateOutBound);
	}

	__animate_in() {
		let time = performance.now() - this.animation.in_animation_start_time;
		this.bounds.right += animationEase(time / this.animation.in_duration, 1);
		if (this.bounds.right > 0) {
			this.bounds.right = 0;
		}

		this.__update_element();
		if (this.bounds.right < 0) {
			requestAnimationFrame(this.__animateInBound);
		} else {
			this.state = NotificationState.WAITING_FOR_INTERACTION;
		}
	}

	__animate_out() {
		let time = performance.now() - this.animation.out_animation_start_time;
		this.bounds.height -= animationEase(time / this.animation.out_duration, 3) + 1.5;
		this.bounds.alpha -= animationEase((time / this.animation.out_duration) * 0.01, 3);
		if (this.bounds.height < 0) {
			this.bounds.height = 0;
		}
		if (this.bounds.alpha < 0) {
			this.bounds.alpha = 0;
		}

		this.__update_element();
		if (this.bounds.height > 0) {
			requestAnimationFrame(this.__animateOutBound);
		} else {
			this.state = NotificationState.DISTROYED;
			this.__onDidFinishAnimation();
		}
	}

	__update_element() {
		if (this.element != undefined) {
			this.element.style.top = `${this.bounds.top}px`;
			this.element.style.right = `${this.bounds.right}px`;
			this.element.style.height = `${this.bounds.height}px`;
			this.element.style.opacity = `${this.bounds.alpha}`;
		}
	}
};

var NotificationCenter = {};

NotificationCenter.already_displaying_notification = false;
NotificationCenter.delivered_notifications = [];
NotificationCenter.notification_by_identifier = {};
NotificationCenter.notification_queue = []; // New queue to store notifications

///Accepts a Notification object
NotificationCenter.add = function (notification) {
	// Add the notification to the queue
	this.notification_queue.push(notification);
	console.log('debug already_displaying_notification : ', this.already_displaying_notification);
	if (this.already_displaying_notification == false) {
		this.displayNextNotification(); // Display the next notification in the queue after a delay
	}
};

NotificationCenter.displayNextNotification = async function () {
	console.log('debug already_displaying_notification 2 : ', this.notification_queue.length);
	if (this.notification_queue.length > 0) {
		this.already_displaying_notification = true;
		const notification = this.notification_queue.shift();
		this.delivered_notifications.push(notification);
		this.notification_by_identifier[notification.identifier] = notification;
		await this.__add_notification_to_DOM(notification);
		if (notification.options.expire_time != undefined && notification.options.expire_time != 0) {
			notification.expire_timeout = setTimeout(() => {
				console.log('Hide');
				this.removeDeliveredNotificationsWithIdentifiers([notification.identifier]);
			}, notification.options.expire_time);
		}
		// this.displayNextNotification();
		setTimeout(() => {
			this.displayNextNotification();
		}, 1500);
	} else if (this.already_displaying_notification == true && this.notification_queue.length == 0) {
		this.already_displaying_notification = false;
	}
};

///An array of Notification objects representing the notifications that have been delivered and are still visible in Notification Center. If no notifications are visible in Notification Center, the array is empty.
NotificationCenter.getDeliveredNotifications = function () {
	return this.delivered_notifications;
};
///An array of String objects, each of which corresponds to a value in the identifier property of a Notification object.
NotificationCenter.removeDeliveredNotificationsWithIdentifiers = function (identifiers) {
	for (const index in identifiers) {
		let identifier = identifiers[index];
		for (let i = 0; i < this.delivered_notifications.length; i++) {
			if (this.delivered_notifications[i].identifier == identifier) {
				this.delivered_notifications[i].startAnimationOut();
				this.delivered_notifications[i].__onDidFinishAnimation = () => {
					for (let j = 0; j < this.delivered_notifications.length; j++) {
						//Have to re-get the array index due to the possibility of a different notification being added or removed during the animation
						if (this.delivered_notifications[j].identifier == identifier) {
							this.delivered_notifications.splice(j, 1);
							delete this.notification_by_identifier[identifier];
							NotificationCenter.__distroy_from_DOM(identifier);
						}
					}
				};
			}
		}
	}
};
NotificationCenter.removeAllDeliveredNotifications = function () {
	for (let i = 0; i < this.delivered_notifications.length; i++) {
		let identifier = this.delivered_notifications[i].identifier;
		this.delivered_notifications[i].startAnimationOut();
		this.delivered_notifications[i].__onDidFinishAnimation = () => {
			this.delivered_notifications.splice(0, 1); //0 due to the array length constantly changing.
			delete this.notification_by_identifier[identifier];
			NotificationCenter.__distroy_from_DOM(identifier);
		};
	}
};

NotificationCenter.__add_notification_to_DOM = function (notification) {
	if (notification == null || undefined) {
		console.warn('[Add Notification To DOM] No notification given.');
		return;
	}
	let notification_html = '';

	notification_html += `<div id="${notification.identifier}" class="notification ${notification.type}">`;
	notification_html += `<div class="notification_top_half">`;
	if (notification.has_close_button) {
		// notification_html += `<i class="material-icons notification_close_button" onclick="NotificationCenter.removeDeliveredNotificationsWithIdentifiers(['${notification.identifier}'])">close</i>`;
		notification_html += `<i class="material-icons notranslate notification_close_button" data-identifier="${notification.identifier}">close</i>`;
	}

	notification_html += `<div class="notification_icon_container">`;
	notification_html += `<i class="material-icons notranslate notification_icon">${notification.icon}</i>`;
	notification_html += `</div>`;

	notification_html += `<div class="notification_content_container">`;
	notification_html += `<div class="notification_title_section">`;
	notification_html += `<h1 class="notification_title">${notification.title || ''}</h1>`;
	notification_html += `</div>`;

	notification_html += `<div class="notification_body_section">`;
	notification_html += `<h2 class="notification_body">${notification.body || ''}</h2>`;
	notification_html += `</div>`;

	notification_html += `<div class="notification_custom_section">`;
	notification_html += `${notification.custom_html}`;
	notification_html += `</div>`;

	notification_html += `</div>`;
	notification_html += `</div>`;

	notification_html += `<div class="notification_bottom_half">`;
	notification_html += `<div class="notification_buttons_container">`;
	if (notification.isBanner == false) {
		for (let i = 0; i < notification.action_buttons.length; i++) {
			let button = notification.action_buttons[i];
			let button_html = `<button id="${button.id}" notification-identifier="${notification.identifier}" ${button.active ? 'active' : ''} ${button.distructive ? 'distructive' : ''} class="notification_button ${button.style} ${notification.type}_text_color" style="${button.custom_css}" onclick='NotificationCenter.__button_clicked(this);'>${button.text}</button>`;
			notification_html += button_html;
		}
	}
	notification_html += `</div>`;
	notification_html += `</div>`;
	notification_html += `</div>`;
	if (document.querySelector('.notifications_center')) {
		document.querySelector('.notifications_center').innerHTML += notification_html;
	}
	notification.DOMElement = document.querySelector(`#${notification.identifier}`);
	// $(".notifications_center").append(notification_html)[0];
	// notification.DOMElement = $("#"+notification.identifier).get(0);

	notification.__onDidCreate();
	notification.__update_element();
	if (notification.options.on_creation != undefined || null) {
		notification.options.on_creation();
	}
};

// NotificationCenter.__distroy_from_DOM = function(identifier) { $("#"+identifier).remove(); }
NotificationCenter.__distroy_from_DOM = function (identifier) {
	console.log('debug already_displaying_notification 3 : ', this.already_displaying_notification == true, this.notification_queue.length == 0);
	if (this.already_displaying_notification == true && this.notification_queue.length == 0) {
		this.already_displaying_notification = false;
	}
	document.querySelector(`#${identifier}`).remove();
};

NotificationCenter.__button_clicked = function (element) {
	let button_id = element.id;
	let buttons_notification = this.notification_by_identifier[element.getAttribute('notification-identifier')];
	if (buttons_notification == null || undefined) {
		console.warn("[Notification Center] Couldn't find notification with identifier of ", element.getAttribute('notification-identifier'));
		return;
	}

	for (let i = 0; i < buttons_notification.action_buttons.length; i++) {
		let button = buttons_notification.action_buttons[i];
		if (button.id == button_id) {
			button.onclick();

			if (button.dismiss_notification_after_click) {
				NotificationCenter.removeDeliveredNotificationsWithIdentifiers([buttons_notification.identifier]);
			}
		}
	}
};

NotificationHandler.NotificationCenter = NotificationCenter;

function _chr4() {
	return Math.random().toString(16).slice(-4);
}

function animationEase(value, power = 3) {
	return 1 - Math.pow(1 - value, power);
}

document.addEventListener('click', function (event) {
	if (event.target.classList.contains('notification_close_button')) {
		const identifier = event.target.getAttribute('data-identifier');
		NotificationCenter.removeDeliveredNotificationsWithIdentifiers([identifier]);
	}
});

export { NotificationHandler, NotificationCenter, NotificationType };
